var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/* tslint:disable:jsx-no-multiline-js */
import classnames from 'classnames'; // react不支持多个className 该插件可以写多个className
import React from 'react';
import ChildBoard from './board';
import BoardsTitle from './title';
export default class Boards extends React.Component {
    constructor(props) {
        super(props);
        this.renderBoardsList = (isShowDivideLine, children) => {
            if (Array.isArray(children)) {
                if (children.length > 4) {
                    children = children.slice(0, 4);
                }
                return children.map((child, index) => {
                    return React.cloneElement(child, { isShowDivideLine, index });
                });
            }
            else { // 这种传参方式只能传字符串 无法传boolean
                return (React.cloneElement(children, { isOnlyOneChild: 1 }));
            }
        };
        this.state = {};
    }
    render() {
        const _a = this.props, { prefixCls, children, className, style, isShowTitle, titleLeftText, titleRightText, isShowDivideLine, onTitleClick } = _a, restProps = __rest(_a, ["prefixCls", "children", "className", "style", "isShowTitle", "titleLeftText", "titleRightText", "isShowDivideLine", "onTitleClick"]);
        const wrapCls = classnames(prefixCls, className);
        const childrenLength = Array.from(children).length;
        const listWrapperHeight = childrenLength === 1 ? "52px" : "76px";
        const titleHeight = 44;
        const childrenHeight = childrenLength === 1 ? 52 : 76;
        const wrapperHeight = isShowTitle ? `${titleHeight + childrenHeight}px` : `${childrenHeight}`;
        return (<div className={wrapCls}>
        <div className={`${prefixCls}-wrapper`} style={{ height: wrapperHeight }}>
          <div className={`${prefixCls}-title-wrapper`} style={{ display: isShowTitle ? "block" : "none" }}>
            <BoardsTitle onTitleClick={onTitleClick} titleLeftText={titleLeftText} titleRightText={titleRightText} {...restProps}></BoardsTitle>
          </div>
          <div className={`${prefixCls}-boards-list-wrapper`} style={{ height: listWrapperHeight }}>
            {this.renderBoardsList(isShowDivideLine, children)}
          </div>
        </div>
      </div>);
    }
}
Boards.ChildBoard = ChildBoard;
Boards.defaultProps = {
    prefixCls: 'bs-number-boards'
};



// WEBPACK FOOTER //
// ./components/boards/index.tsx